import { render, staticRenderFns } from "./informationtype.vue?vue&type=template&id=150f662a&scoped=true"
import script from "./informationtype.vue?vue&type=script&lang=js"
export * from "./informationtype.vue?vue&type=script&lang=js"
import style0 from "./informationtype.vue?vue&type=style&index=0&id=150f662a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "150f662a",
  null
  
)

export default component.exports